export function integerValidator($el) {
  if (!$el.val()) {
    return true;
  }
  const value = $el[0].valueAsNumber;
  return !isNaN(value) && value % 1 === 0;
}
Foundation.Abide.defaults.validators["integer"] = integerValidator;
